import type { ClientModel } from '@/adapters/apiv1.g';
import type { Client } from '@/types/core/client';
import type { UUID } from '@/utils/uuid';

/**
 * Transform a backend ClientModel to a frontend Client type.
 * Handles snake_case to camelCase conversion and provides safe defaults.
 */
export function extractClient(model: ClientModel): Client {
  return {
    clientId: (model.client_id ?? '') as UUID,
    tenantId: (model.tenant_id ?? '') as UUID,
    name: model.name ?? '',
    description: model.description ?? '',
    roleIds: (model.role_ids ?? []) as UUID[],
    capabilities: (model.capabilities ?? []) as string[],
    expiresAt: model.expires_at ?? '',
    isRevoked: model.is_revoked ?? false,
    enabled: model.enabled ?? false,
    createdBy: model.created_by ?? '',
    revokedAt: model.revoked_at ?? '',
    revokedBy: model.revoked_by ?? '',
  };
}
